module.exports = __webpack_public_path__ + "images/emoji/back.bee7d48d327e998c0f0d.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/back.png
// module id = EkUS
// module chunks = 13